import Nullstack from 'nullstack';
export default function IconTransitionBottom({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-transition-bottom",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M21 18a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3"
  }), "   ", Nullstack.element("rect", {
    x: "3",
    y: "3",
    width: "18",
    height: "6",
    rx: "3"
  }), "   ", Nullstack.element("path", {
    d: "M12 9v8"
  }), "   ", Nullstack.element("path", {
    d: "M9 14l3 3l3 -3"
  }), " ");
}